import { useEffect } from 'react';

/**
 * Custom hook to prevent body scrolling when modal is open
 * @param {boolean} isOpen - Whether the modal is currently open
 */
const useModalScrollLock = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Simple approach: just prevent scrolling without complex positioning
      // This works better with the existing scale transform

      // Store original overflow styles
      const originalHtmlOverflow = document.documentElement.style.overflow;
      const originalBodyOverflow = document.body.style.overflow;

      // Prevent scrolling on both html and body
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      // Cleanup function to restore scrolling when modal closes
      return () => {
        // Restore original overflow styles
        document.documentElement.style.overflow = originalHtmlOverflow;
        document.body.style.overflow = originalBodyOverflow;
      };
    }
  }, [isOpen]);
};

export default useModalScrollLock;
